module.exports = __webpack_public_path__ + "img/BOS.98dd0d8a.svg";